export default __webpack_public_path__ + "static/media/enter-point-restricted.c436397e.svg";